import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Clock = forwardRef<SVGSVGElement, SvgIconProps>(
  function Clock(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M12 2a10 10 0 000 20 10 10 0 000-20zm4.91 11h-4.85c-.58 0-1.06-.43-1.06-.95v-5.1c0-.52.48-.95 1.06-.95.6 0 1.07.43 1.07.95v4.16h3.8c.6 0 1.07.43 1.07.96 0 .52-.5.93-1.09.93z" />
      </SvgIcon>
    )
  },
)

export default Clock
